import { useDispatch, useSelector } from "react-redux";
import { updateUserPreferences } from "../../api/users/updateUserPreferences";
import { setSessionPreferences } from "../../store/Session";
import { StoreInterfaces } from "../../types/store";
import { UserPreferences } from "../../types/ui";
import { useErrorHandler } from "../Error/useErrorHandler";

export const useUserPreferences = () => {
  const dispatch = useDispatch();
  const handleError = useErrorHandler();
  const session = useSelector((state: StoreInterfaces) => state.session);

  const updatePreferences = async (preferences: UserPreferences) => {
    try {
      await updateUserPreferences(
        session.accountId,
        session.userId,
        preferences,
      );
      dispatch(setSessionPreferences(preferences));
    } catch (error) {
      handleError(error);
    }
  };

  return {
    preferences: session?.preferences as UserPreferences,
    updatePreferences,
  };
};